import React from "react";
import BTNCLOContent from "../../components/layouts/tentang/BTNCLOContent";

const BTNCLO: React.FC = () => {
  return (
    <div>
      <BTNCLOContent />
    </div>
  );
};

export default BTNCLO;
